import React from "react";
import CompactUploadRow from "./CompactUploadRow.jsx";
import SleekUploadTile from "../../../../components/ui/SleekUploadTile.jsx";
import {
  ALL_UPLOAD_BUCKETS,
  UPLOAD_FORMAT_HINT,
  countUploadedBuckets,
} from "./borrowerUploadConfig.js";

export default function FormUploadsPanel({
  uploads,
  uploadingFiles,
  onUpload,
  onRemove,
  buckets = ALL_UPLOAD_BUCKETS,
}) {
  const { uploaded, total } = countUploadedBuckets(uploads, buckets);

  return (
    <div className="space-y-5">
      <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600">
        <p>{UPLOAD_FORMAT_HINT}</p>
        <p className="mt-1 font-semibold text-slate-700">
          {uploaded} of {total} document types uploaded
        </p>
      </div>

      {/* Mobile — compact list rows (unchanged) */}
      <div className="md:hidden space-y-2">
        {buckets.map((bucket) => (
          <CompactUploadRow
            key={bucket.key}
            id={`upload-${bucket.key}`}
            title={bucket.title}
            multiple={bucket.multiple}
            button={bucket.button || "Select File"}
            existingFiles={uploads[bucket.key] || []}
            uploadingFiles={uploadingFiles[bucket.key] || []}
            onFiles={onUpload(bucket.key, bucket.fieldname)}
            onRemove={onRemove(bucket.key)}
          />
        ))}
      </div>

      {/* Desktop — larger drag-and-drop tiles (v7/v8 style) */}
      <div className="hidden md:grid grid-cols-2 gap-4">
        {buckets.map((bucket) => (
          <SleekUploadTile
            key={bucket.key}
            title={bucket.title}
            sub={UPLOAD_FORMAT_HINT}
            button={bucket.button || (bucket.multiple ? "Select Files" : "Select File")}
            multiple={!!bucket.multiple}
            existingFiles={uploads[bucket.key] || []}
            uploadingFiles={uploadingFiles[bucket.key] || []}
            onFiles={onUpload(bucket.key, bucket.fieldname)}
            onRemove={onRemove(bucket.key)}
          />
        ))}
      </div>
    </div>
  );
}
